import { createSaga } from './saga-helpers';

import * as Api from '../api/folders-api';

const watchGetFolders = createSaga({
    type: 'FOLDERS_FETCH',
    fn: Api.fetchFolders,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        folders: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateFolder = createSaga({
    type: 'FOLDER_CREATE',
    fn: Api.createFolder,
    args: action => [action.payload.folder],
    successPayload: ({ id: folderId }, action) => ({
        folderId,
        fragment: action.payload.folder
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.folder
    })
});

const watchGetFolder = createSaga({
    type: 'FOLDER_FETCH',
    fn: Api.fetchFolder,
    args: action => [action.payload.folderId],
    successPayload: folder => ({ folder })
});

const watchUpdateFolder = createSaga({
    type: 'FOLDER_UPDATE',
    fn: Api.updateFolder,
    args: action => [action.payload.folderId, action.payload.folderProps],
    successPayload: folder => ({ folder })
});

const watchRemoveFolder = createSaga({
    type: 'FOLDER_REMOVE',
    fn: Api.removeFolder,
    args: action => [action.payload.folderId]
});

const sagas = [watchGetFolders, watchCreateFolder, watchGetFolder, watchUpdateFolder, watchRemoveFolder];

export default sagas;
